export default __webpack_public_path__ + "static/media/arrow-down-blue.30d6ef11.svg";